import { CHANGE_COLLAPSE } from "./constants";

const mutations = {
    [CHANGE_COLLAPSE](state){
        state.isCollapse = !state.isCollapse
    } 
}

export default mutations